import React, { Fragment, useState, useEffect } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormGroup,
  Form,
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap";
import { useForm } from "react-hook-form";
import DataTable from "react-data-table-component";
import { H3, Btn, Breadcrumbs, H4 } from "../../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import SweetAlert from "sweetalert2";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";

import {
  getclientpackage,
  getIndustryUser,
  getpackageselect,
  getUserSubscription,
} from "../../../CommonURL";
import {
  getDataWithToken,
  postDataWithToken,
  postMasterToken,
} from "../../../Utils/restUtils";
import { Add, Delete, Edit } from "../../../Constant";
import { CompanyColumns } from "../../../Data/MockTable/CompanyData";
import SearchList from "../../../CommonElements/Search";
import { SubscriptionColumns } from "../../../Data/MockTable/TableHeaderList";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import IndustryFilter from "../../Common/Filters/IndustryFilter";
import CompanyFilter from "../../Common/Filters/CompanyFilter";
import { selectRoleId } from "../../../Redux/personalDetail";
import { useSelector } from "react-redux";

const SubscriptionTable = () => {
  const roleId = useSelector(selectRoleId);
  const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: "10px" };
  const [companyList, setCompanyList] = useState([]);
  const [companyData, setCompanyData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchResetKey, setSearchResetKey] = useState(0);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isIndustry, setIsIndustry] = useState("");
  const [packageOptions, setPackageOptions] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({});
  const [isCompany, setIsCompany] = useState(null);
  const [dateRange, setDateRange] = useState([
    //   filters.start_date,
    //   filters.end_date,
  ]);
  const [startDate, endDate] = dateRange;
  const navigate = useNavigate();
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  useEffect(() => {
    subscriptionData(1, perPage, {});
  }, []);

  useEffect(() => {
    setSelectedPackage("");
    loadPackages(isIndustry);
  }, [isIndustry]);

  const handleFilter = () => {
    const filters = {
      industry_id: isIndustry?.value || "",
      company_id:isCompany?.value || "",
      package_id: selectedPackage || "",
      start_date: startDate ? startDate.toISOString().split("T")[0] : "",
      end_date: endDate ? endDate.toISOString().split("T")[0] : "",
      search: searchKeyword,
    };

    setAppliedFilters(filters);
    setCurrentPage(1);
    subscriptionData(1, perPage, filters);
  };

  const SubscriptionColumns = [
    {
      name: <H4>Sl No</H4>,
      selector: (row) => row.Si,
      sortable: true,
      width: "70px",
      center:true
    },
    roleId === 1 &&{
      name: <i className="fa fa-gears" style={{ fontSize: "15px" }}></i>,
      selector: (row) => row.action,
      cell: (row) => <ActionCell row={row} />,
      center: true,
      width: "55px",
    },
     {
        name: <H4>Company Name</H4>,
        selector: (row) => (
          <Link
            to={`${process.env.PUBLIC_URL}/subscriptions/companyProfile?id=${row.CompanyId}&user_id=${row.User_id}&industryId=${row.industryTypeId}`}
            state={{
              clientUrl: row.client_url,
              industryName: row.Industry,
            }}
          >
            {row.Company}
          </Link>
        ),
        sortable: true,
        width: "190px",
        wrap: true,
      },
         {
      name: <H4>Company Id</H4>,
      selector: (row) => row.CompanyId,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: <H4>Package Name</H4>,
      selector: (row) => row.PackageName,
      sortable: true,
      width: "130px",
      wrap: true,
    },
    {
      name: <H4>Unit Price</H4>,
      selector: (row) => (
        <span className="billerq_color fw-bolder">$ {row.Price}</span>
      ),
      sortable: true,
      width: "110px",
    },
    {
      name: <H4>Industry</H4>,
      selector: (row) => row.Industry,
      sortable: true,
      width: "130px",
      wrap: true,
    },
     {
      name: <H4>User Name</H4>,
      selector: (row) => (
        <Link
          to={`${process.env.PUBLIC_URL}/subscriptions/company-list/userProfile?id=${row.User_id}`}
        >
          {row.Name}
        </Link>
      ),
      sortable: true,
      width: "110px",
      wrap: true,
    },
      {
      name: <H4>User Id</H4>,
      selector: (row) => row.UserId,
      sortable: true,
      width: "130px",
      wrap: true,
    },
   
    {
      name: <H4>Start date</H4>,
      selector: (row) => row.Start_date,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: <H4>End date</H4>,
      selector: (row) => row.End_date,
      sortable: true,
      width: "150px",
      wrap: true,
    },
    {
      name: <H4>Status</H4>,
      selector: (row) => row.Status,
      sortable: true,
      cell: (row) => (
        <span className={`badge badge-${row.Status}`}>{row.Status}</span>
      ),
      width: "90px",
    },
    // {
    //   name: <H4>Action</H4>,
    //   selector: row => row.action,
    //   sortable: true,
    // }
  ].filter(Boolean);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    subscriptionData(page, perPage, appliedFilters);
  };
 const ResetFileter = () => {
  setIsCompany(null);
  setIsIndustry(null);
  setDateRange([null, null]);
  setSearchResetKey(prev => prev + 1); 
  setAppliedFilters({});
  setCurrentPage(1);
  subscriptionData(1, perPage, {});
};
  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    subscriptionData(page, newPerPage, appliedFilters);
  };

  const redirectToEditForm = (data) => {
    const editFormURL = `${process.env.PUBLIC_URL}/billing/subscription-edit?id=${data}`;
    navigate(editFormURL);
  };
  const loadPackages = async (industryId) => {
    if (!industryId?.value) {
      setPackageOptions([]);
      setSelectedPackage("");
      return;
    }

    try {
      const res = await getDataWithToken(
        `${getpackageselect}?industry_type_id=${industryId.value}`,
      );
      if (res?.status === true && Array.isArray(res?.data)) {
        setPackageOptions(res.data);
      } else {
        setPackageOptions([]);
      }
    } catch (err) {
      setPackageOptions([]);
    }
  };

  const ActionCell = ({ row }) => {
    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    return (
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle
          color="#00000"
          style={{ fontSize: "14px", zIndex: 1000 }}
        >
          <i className="fa fa-ellipsis-v"></i>
        </DropdownToggle>
        <DropdownMenu container="body">
          <DropdownItem
            style={toggleStyle}
            onClick={() => redirectToEditForm(row.Id)}
          >
            {Edit}
          </DropdownItem>
          <DropdownItem
            style={{
              padding: "10px 20px",
              color: "red",
              opacity: "0.8",
              fontSize: "14px",
              margin: "0",
            }}
            onClick={() => deleteCompanyList()}
          >
            {Delete}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  const deleteCompanyList = (userId) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "cancel",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        const deleteRes = { package_id: userId };
        const packageRemove = await postDataWithToken(deletePackage, deleteRes);
        if (packageRemove.data.message === "success") {
          SweetAlert.fire("Deleted!", "Your file has been deleted.", "success");
          getPackagesData();
        } else {
          navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        }
      } else {
      }
    });
  };

  const filteredItems = companyData?.filter(
    (item) =>
      (item.first_name &&
        item.first_name.toLowerCase().includes(searchKeyword.toLowerCase())) ||
      (item.last_name &&
        item.last_name.toLowerCase().includes(searchKeyword.toLowerCase())) ||
      (item.industry_name &&
        item.industry_name.toLowerCase().includes(searchKeyword.toLowerCase())),
  );

  const updateSearchKeyword = (keyword) => {
    setSearchKeyword(keyword);
  };

  const subscriptionData = async (page, size = perPage, filters = {}) => {
    setLoading(true);

    const query = new URLSearchParams({
      page,
      page_length: size,
      search: filters.search || "",
      industry_id: filters.industry_id || "",
      company_id:filters.company_id || "",
      package_id: filters.package_id || "",
      start_date: filters.start_date || "",
      end_date: filters.end_date || "",
      user_id: "",
    }).toString();

    const response = await getDataWithToken(`${getUserSubscription}?${query}`);

    setCompanyData(response?.data?.data || []);
    setTotalRows(response?.data?.total || 0);
    setLoading(false);
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs
        mainTitle="Subscription"
        parent="Configuration"
        title="Subscription"
      />
      <Card>
        <CardHeader>
          <H3>Subscription List</H3>
        </CardHeader>
        <div className="px-4 pb-2">
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleFilter();}}>
          <Row className="g-3 align-items-center">
            <Col sm="12" md="5" lg="3" className="pt-3">
              <SearchList
                key={searchResetKey}
                className="form-control"
                updateSearchKeyword={updateSearchKeyword}
                onEnter={handleFilter}
              />
            </Col>
           
            <Col sm="12" md="6" lg="3">
              <IndustryFilter
                IsIndustry={isIndustry}
                setIsIndustry={setIsIndustry}
              />
            </Col>
            <Col sm="12" md="5" lg="3" className="form-element">
              <CompanyFilter
                IsCompany={isCompany}
                setIsCompany={setIsCompany}
                industryId={isIndustry?.value}
              />
            </Col>
            <Col sm="12" md="6" lg="3">
              <select
                className="form-select"
                value={selectedPackage}
                disabled={!isIndustry?.value}
                 style={!isIndustry?.value ? {
                       backgroundColor: "#f5f5f5",
                       color: "#999"
                   } : {}}
                onChange={(e) => {
                  setSelectedPackage(e.target.value);
                }}
              >
                <option value="">
                  {isIndustry?.value ? "All Packages" : "Select Industry First"}
                </option>

                {packageOptions.map((pkg) => (
                  <option key={pkg.id} value={pkg.id}>
                    {pkg.name}
                  </option>
                ))}
              </select>
            </Col>
             <Col sm="12" md="5" lg="3">
              <div style={{ position: "relative", zIndex: 2 }}>
                <DatePicker
                  className="form-control digits w-100"
                  selectsRange
                  startDate={startDate}
                  endDate={endDate}
                  onChange={(update) => setDateRange(update)}
                  isClearable={!!(startDate || endDate)}
                  monthsShown={2}
                  calendarClassName="parallel-calendar"
                  placeholderText="Select Date Range"
                  dateFormat="dd-MM-yyyy" 
                />
              </div>
            </Col>
              <Col sm="12" md="6" lg="3">
                <div style={{ display: "flex", gap: "10px" }}>
                  <button className="btn btn-primary" onClick={handleFilter}>
                    Filter
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={ResetFileter}
                  >
                    Reset
                  </button>
                </div>
              </Col>
          </Row>
          </Form>
        </div>

        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              columns={SubscriptionColumns}
              data={companyData?.map((e, index) => ({
                Si: index + 1,
                Name: e.user_name,
                UserId:e.user_id,
                PackageName: e.package_name,
                Price: e.price,
                Industry: e.industry_name,
                Company:e.company_name,
                CompanyId:e.company_id,
                Start_date: e.start_date,
                End_date: e.end_date,
                Status: e.status,
                Id: e.id,
                User_id: e.user_id,
                industryTypeId:e.industry_type_id,
                client_url:e.client_url
              }))}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default SubscriptionTable;
